module.exports = __webpack_public_path__ + "img/231.b61d753a.png";